import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { faTrianglePersonDigging } from '@/lib/fontAwesomePro/solid'

interface Props {
  onClick: () => void
}

const DevLogo: React.FC<Props> = ({ onClick }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span>
        <FontAwesomeIcon
          icon={faTrianglePersonDigging}
          className="text-warning cursor-pointer text-[26px]"
          onClick={onClick}
        />
      </span>
    </TooltipTrigger>

    <TooltipContent>
      You're viewing the non-production version of RQ. Click on the icon to hide
      it.
    </TooltipContent>
  </Tooltip>
)

export default DevLogo
